module.exports = __webpack_public_path__ + "static/004283-1fa959d461b95e0dca0f6b921d1d4d6a.jpg";